import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import api from "../../api/client";
import { PageSection } from "../PageSection";
import { DecorativeRow } from "../DecorativeRow";

export const Contact = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  async function handleSubscribe(e) {
    e.preventDefault();
    setError("");
    const trimmed = email.trim().toLowerCase();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError("Please enter a valid email address.");
      return;
    }
    try {
      await api.post("/contacts", { email: trimmed });
      setSubmitted(true);
    } catch (err) {
      setError(err?.message || "Something went wrong. Please try again.");
    }
  }

  return (
  <PageSection className="contact" id="contact">
    <DecorativeRow />

    <div className="contact-content">
      <Row className="align-items-start">
        <Col lg={5} md={12} className="contact-heading-col">
          <h1><span className="tagline">Contact Us</span></h1>
          <p className="contact-intro">We'd love to hear from you! Reach out for catering inquiries, event bookings, or just to say hello.</p>
        </Col>

        <Col lg={7} md={12} className="contact-links-col">
          <div className="contact-list">
            <a className="contact-item" href="tel:+12052662587">
              <div className="contact-detail">
                <span className="contact-type">Phone</span>
                <span className="contact-value">(205) 266-2587</span>
              </div>
            </a>

            <a className="contact-item" href="mailto:lilbougiefoodie@gmail.com">
              <div className="contact-detail">
                <span className="contact-type">Email</span>
                <span className="contact-value">lilbougiefoodie@gmail.com</span>
              </div>
            </a>

            <a className="contact-item" href="https://www.instagram.com/the_lil_bougie_foodie" target="_blank" rel="noreferrer">
              <div className="contact-detail">
                <span className="contact-type">Instagram</span>
                <span className="contact-value">@the_lil_bougie_foodie</span>
              </div>
            </a>

            <a className="contact-item" href="https://www.facebook.com/Thelilbougiefoodie" target="_blank" rel="noreferrer">
              <div className="contact-detail">
                <span className="contact-type">Facebook</span>
                <span className="contact-value">The Lil Bougie Foodie</span>
              </div>
            </a>

            <a className="contact-item" href="https://play.google.com/store/apps/details?id=com.lilbougiefoodie.app" target="_blank" rel="noreferrer">
              <div className="contact-detail">
                <span className="contact-type">Get Our App</span>
                <span className="contact-value">Play Store</span>
              </div>
            </a>
          </div>

    <div className="contact-subscribe">
      <h2 className="contact-subscribe-heading">Stay in the Loop</h2>
      <p className="contact-subscribe-text">Sign up for our mailing list to get updates on locations, specials, and events.</p>
      {submitted ? (
        <p className="contact-subscribe-thanks">Thank you for subscribing!</p>
      ) : (
        <form className="contact-subscribe-form" onSubmit={handleSubscribe}>
          <input
            type="text"
            className="contact-subscribe-input"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit" className="btn-cta contact-subscribe-btn">Subscribe</button>
          {error && <p className="contact-subscribe-error">{error}</p>}
        </form>
      )}
    </div>
        </Col>
      </Row>
    </div>

    <DecorativeRow position="bottom" />
  </PageSection>
);
};
